module.exports = {
      id: "shortform-usage",
      viewBox: "0 0 13.07 13.758",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#shortform",
      toString: function () {
        return this.url;
      }
    }